import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, LogIn } from "lucide-react";
import Navbar from "@/components/Navbar";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "organiser" ? "/portal" : "/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-20">
        <div className="bg-ec-surface border border-white/10 p-8">
          <div className="flex items-center gap-2.5 mb-2">
            <Shield className="text-ec-volt" size={22} />
            <h1 className="font-heading text-4xl tracking-wide leading-none">Sign In</h1>
          </div>
          <p className="text-zinc-400 text-sm mb-8">Admins and trusted organisers — sign in to manage events.</p>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <label className="block">
              <span className="overline text-zinc-500 mb-2 block">Email</span>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-black/40 border border-white/10 px-3.5 py-3 focus:outline-none focus:border-ec-volt transition-colors"
                placeholder="admin@eventcity.uk"
              />
            </label>
            <label className="block">
              <span className="overline text-zinc-500 mb-2 block">Password</span>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-black/40 border border-white/10 px-3.5 py-3 focus:outline-none focus:border-ec-volt transition-colors"
                placeholder="••••••••"
              />
            </label>

            {error && <p data-testid="login-error" className="text-ec-red text-sm">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full inline-flex items-center justify-center gap-2 overline bg-ec-volt text-black px-6 py-3.5 hover:bg-ec-volt-hover transition-colors disabled:opacity-50"
            >
              <LogIn size={16} /> {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
